// src/services/axiosInstance.js
import axios from 'axios';
import store from '@/store';
import router from '@/router';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // Replace with your API URL
  //timeout: 10000, // Request timeout in ms
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add interceptors if needed
axiosInstance.interceptors.request.use(
    (config) => {
      const language = store.getters.currentLanguage;
      const token = store.getters.accessToken;
      // Set the 'Accept-Language' header to the current language
      if (language) {
          config.headers['Accept-Language'] = language;
        }
        else{
          config.headers['Accept-Language'] = 'en';
        }
      // You can add token here if needed
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } 
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error && error.status === 401 ) {
      store.dispatch('logout'); // Dispatch a logout action to clear user data
      router.push('/login'); // Redirect to the login page
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
